module.exports = __webpack_public_path__ + "img/bxs-stared.2fc3f05e.svg";